import { useState } from 'react';

interface MediaItem {
  id: number;
  type: 'image' | 'video';
  src: string;
  thumbnail?: string;
  title: string;
  category: string;
}

const mediaItems: MediaItem[] = [
  {
    id: 1,
    type: 'video',
    src: 'https://www.youtube.com/embed/vv4lX6JVYiU?autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/vv4lX6JVYiU/maxresdefault.jpg',
    title: 'Estimulación de Cachorros',
    category: 'Vídeos'
  },
  {
    id: 2,
    type: 'image',
    src: 'https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/69b59b97bba827098d22ea8c7d7e4cb7.jpeg',
    title: 'Modificación de Conducta',
    category: 'Cursos'
  },
  {
    id: 3,
    type: 'image',
    src: 'https://public.readdy.ai/ai/img_res/bb44d4ac95b6401ddc41e9e581fdd0cb.jpg',
    title: 'Cuidados e Higiene Canina',
    category: 'Cursos'
  },
  {
    id: 4,
    type: 'image',
    src: 'https://readdy.ai/api/search-image?query=veterinary%20professional%20demonstrating%20first%20aid%20techniques%20on%20friendly%20dog%20in%20clinical%20setting%20with%20professional%20equipment%20and%20neutral%20background&width=1200&height=800&seq=gallery004&orientation=landscape',
    title: 'Primeros Auxilios Caninos',
    category: 'Cursos'
  },
  {
    id: 5,
    type: 'video',
    src: 'https://www.youtube.com/embed/tQHbu-LK_Vk?autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/tQHbu-LK_Vk/maxresdefault.jpg',
    title: 'Iniciación del Cachorro a la Detección',
    category: 'Vídeos'
  },
  {
    id: 6,
    type: 'image',
    src: 'https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/d64ef64ad8315293dac533adce4b514e.jpeg',
    title: 'Nuestras Instalaciones',
    category: 'Instalaciones'
  },
  {
    id: 7,
    type: 'video',
    src: 'https://www.youtube.com/embed/3dWEq_so7WI?autoplay=1&rel=0',
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20dog%20trainer%20teaching%20advanced%20obedience%20commands%20to%20border%20collie%20in%20outdoor%20training%20area%20with%20natural%20setting&width=800&height=600&seq=gallery007&orientation=landscape',
    title: 'Técnicas de Adiestramiento Avanzado',
    category: 'Vídeos'
  },
  {
    id: 8,
    type: 'image',
    src: 'https://readdy.ai/api/search-image?query=student%20practicing%20positive%20reinforcement%20training%20methods%20with%20beagle%20dog%20using%20treats%20and%20clicker%20in%20professional%20training%20environment&width=1200&height=800&seq=gallery008&orientation=landscape',
    title: 'Práctica con Refuerzo Positivo',
    category: 'Alumnos'
  },
  {
    id: 9,
    type: 'video',
    src: 'https://www.youtube.com/embed/3A376ctWJ5I?autoplay=1&rel=0',
    thumbnail: 'https://readdy.ai/api/search-image?query=adorable%20puppies%20playing%20together%20in%20a%20bright%20outdoor%20park%20during%20socialization%20training%20session%20with%20gentle%20trainer%20and%20soft%20natural%20background&width=800&height=600&seq=gallery009&orientation=landscape',
    title: 'Socialización de Cachorros',
    category: 'Vídeos'
  },
  {
    id: 10,
    type: 'image',
    src: 'https://readdy.ai/api/search-image?query=professional%20dog%20grooming%20and%20hygiene%20care%20session%20showing%20bathing%20and%20brushing%20techniques%20in%20modern%20facility%20with%20clean%20background&width=1200&height=800&seq=gallery010&orientation=landscape',
    title: 'Sesión de Higiene Profesional',
    category: 'Instalaciones'
  },
  {
    id: 11,
    type: 'video',
    src: 'https://www.youtube.com/embed/OIjMBfhyNDE?autoplay=1&rel=0',
    thumbnail: 'https://readdy.ai/api/search-image?query=veterinary%20demonstration%20of%20canine%20first%20aid%20and%20emergency%20care%20techniques%20in%20professional%20clinical%20setting&width=800&height=600&seq=gallery011&orientation=landscape',
    title: 'Primeros Auxilios en Acción',
    category: 'Vídeos'
  },
  {
    id: 12,
    type: 'image',
    src: 'https://readdy.ai/api/search-image?query=happy%20students%20with%20their%20successfully%20trained%20dogs%20showing%20certificates%20and%20achievements%20at%20dog%20training%20academy%20graduation%20ceremony&width=1200&height=800&seq=gallery012&orientation=landscape',
    title: 'Éxito de Nuestros Alumnos',
    category: 'Alumnos'
  }
];

const categories = ['Todos', 'Cursos', 'Alumnos', 'Instalaciones', 'Vídeos'];

export default function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState<MediaItem | null>(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  const filteredMedia = selectedCategory === 'Todos' 
    ? mediaItems 
    : mediaItems.filter(item => item.category === selectedCategory);

  const openLightbox = (item: MediaItem) => {
    setSelectedMedia(item);
    setLightboxOpen(true);
    setImageLoaded(false);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedMedia(null);
    setImageLoaded(false);
    document.body.style.overflow = 'auto';
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      closeLightbox();
    }
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Galería de Fotos y Vídeos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubre nuestras instalaciones, conoce a nuestros alumnos y observa las técnicas profesionales de adiestramiento canino en acción
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-primary-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredMedia.map((item) => (
            <div
              key={item.id}
              onClick={() => openLightbox(item)}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer bg-white"
            >
              <div className="relative w-full h-64">
                <img
                  src={item.type === 'video' ? item.thumbnail : item.src}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Video Play Icon */}
                {item.type === 'video' && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-3xl text-primary-600"></i>
                    </div>
                  </div>
                )}

                {/* Category Badge */}
                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 bg-white/95 backdrop-blur-sm rounded-full text-xs font-semibold text-primary-600">
                    {item.category}
                  </span>
                </div>

                {/* Title Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-white font-semibold text-sm leading-tight">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredMedia.length === 0 && (
          <div className="text-center py-16">
            <i className="ri-image-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-gray-500 text-lg">No hay contenido en esta categoría</p>
          </div>
        )}
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && selectedMedia && (
        <div 
          className="fixed inset-0 z-50 bg-black/96 flex items-center justify-center p-4 animate-fadeIn"
          onClick={closeLightbox}
          onKeyDown={handleKeyDown}
          role="dialog"
          aria-modal="true"
          tabIndex={-1}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 md:top-6 md:right-6 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer z-10 backdrop-blur-sm"
            aria-label="Cerrar"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          {/* Content Container */}
          <div 
            className="max-w-7xl w-full mx-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {selectedMedia.type === 'image' ? (
              <div className="relative">
                {/* Loading Spinner */}
                {!imageLoaded && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 border-4 border-white/20 border-t-white rounded-full animate-spin"></div>
                  </div>
                )}
                
                {/* Image */}
                <img
                  src={selectedMedia.src}
                  alt={selectedMedia.title}
                  className="w-full h-auto max-h-[80vh] object-contain rounded-lg shadow-2xl mx-auto"
                  onLoad={() => setImageLoaded(true)}
                  style={{ display: imageLoaded ? 'block' : 'none' }}
                />
              </div>
            ) : (
              <div className="relative w-full bg-black rounded-lg overflow-hidden shadow-2xl" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  src={selectedMedia.src}
                  title={selectedMedia.title}
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            )}
            
            {/* Title and Category */}
            <div className="mt-6 text-center">
              <h3 className="text-white text-xl md:text-2xl font-bold mb-2">
                {selectedMedia.title}
              </h3>
              <span className="inline-block px-4 py-1.5 bg-primary-600 rounded-full text-sm font-semibold text-white">
                {selectedMedia.category}
              </span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
